import React from "react"
import { Card, CardBody, Row, Col, Badge } from "reactstrap"

const DashboardSummary = ({ data }) => {
  const summaryItems = [
    {
      title: "Platform Health",
      status: "Excellent",
      color: "success",
      description: "All systems operational",
      icon: "mdi mdi-check-circle"
    },
    {
      title: "User Engagement",
      status: "High",
      color: "info", 
      description: "80% daily active users",
      icon: "mdi mdi-trending-up"
    },
    {
      title: "Revenue Growth",
      status: "Growing",
      color: "success",
      description: "+22% this month",
      icon: "mdi mdi-chart-line"
    },
    {
      title: "Support Queue",
      status: "Normal",
      color: "warning",
      description: "23 pending tickets",
      icon: "mdi mdi-help-circle"
    }
  ]

  return (
    <Card className="bg-light border-0">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title mb-0">Platform Overview</h4>
          <Badge color="success" className="badge-soft">
            <i className="mdi mdi-check me-1"></i>
            All Systems Operational
          </Badge>
        </div>

        <Row>
          {summaryItems.map((item, index) => (
            <Col md={6} lg={3} key={index}>
              <div className="d-flex align-items-center mb-3">
                <div className={`avatar-sm rounded-circle bg-${item.color} d-flex align-items-center justify-content-center me-3`}>
                  <i className={`${item.icon} text-white`}></i>
                </div>
                <div>
                  <h6 className="mb-1">{item.title}</h6>
                  <Badge color={item.color} className="badge-soft mb-1">
                    {item.status}
                  </Badge>
                  <p className="text-muted mb-0 font-size-12">{item.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="mt-3 pt-3 border-top">
          <Row className="text-center">
            <Col sm={3}>
              <div>
                <h5 className="mb-1 text-primary">{data?.totalUsers?.toLocaleString() || '15,420'}</h5>
                <p className="text-muted mb-0 font-size-13">Total Users</p>
              </div>
            </Col>
            <Col sm={3}>
              <div>
                <h5 className="mb-1 text-success">{data?.activeUsers?.toLocaleString() || '12,350'}</h5>
                <p className="text-muted mb-0 font-size-13">Active Users</p>
              </div>
            </Col>
            <Col sm={3}>
              <div>
                <h5 className="mb-1 text-info">${data?.totalRevenue?.toLocaleString() || '125,000'}</h5>
                <p className="text-muted mb-0 font-size-13">Revenue</p>
              </div>
            </Col>
            <Col sm={3}>
              <div>
                <h5 className="mb-1 text-warning">{data?.userGrowth?.growth || '27.5'}%</h5>
                <p className="text-muted mb-0 font-size-13">Growth Rate</p>
              </div>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  )
}

export default DashboardSummary